// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Manrope', 'Manrope Fallback'","fontStyle":"normal"},"className":"__className_563826"};